export function description(ext: string): string {
  return `Generates and export the data from an schema or dataset into a ${ext} file`;
}
